import { Button, Input, Typography } from 'mobily-ui-library/lib';
import { GlobalContext } from '../../context/GlobalContext';
import { useContext, useEffect, useState } from 'react';
import Modal from '../Modal/Modal';
import { useTranslation } from 'react-i18next';
import { ConfigProvider, Form } from 'antd';

import './CancelReasonModal.scss';
import { cancellationReason, getODBCancelOTP } from '../../api/api';
import JSEncrypt from 'jsencrypt';
import SelectComponent from '../Select/Select';
import Loading from '../Loading/Loading';

const win: any = window;

function CancelReasonModal() {
    const { state, dispatch }: any = useContext(GlobalContext);
    const { rtl, lang, msisdn, nationalId, loading } = state;
    const { t } = useTranslation();
    const [reasonList, setReasonList] = useState([])
    const [isFormValid, setIsFormValid] = useState(false);

    const [form] = Form.useForm();

    const cancellationReasons: any = {
        1: {
            arabicTxt: 'المدة الزمنية للتنفيذ',
            engTxt: 'Time of execution',
        },
        2: {
            arabicTxt: 'تغيير موقع الخدمة',
            engTxt: 'Change service location',
        },
        3: {
            arabicTxt: 'تكلفة رسوم الإيصال',
            engTxt: 'Cost of delivery request',
        },
        4: {
            arabicTxt: 'أخرى',
            engTxt: 'Others',
        },
    }

    const direction = rtl ? 'rtl' : 'ltr';
    const initialValues = {
        reason: '',
        reasonText: ''
    }
    useEffect(() => {
        getReasons()
    }, [])
    const onValuesChange = () => {
        setTimeout(() => {
            const reason = form.getFieldValue('reason');
            const fieldsToCheck = ['reason'];
            if (reason === 4) fieldsToCheck.push('reasonText');

            const allTouched = form.isFieldsTouched(fieldsToCheck, true);
            const noErrors = form.getFieldsError().every(({ errors }) => errors.length === 0);

            setIsFormValid(allTouched && noErrors);
        }, 0);
    };
    const getReasons = async () => {
        try {
            dispatch({ type: 'SET_LOADER', payload: true });
            const data = {
                "channelId": "1",
                "serviceProviderId": "2"
            }
            const res = await cancellationReason(data);
            dispatch({ type: 'SET_LOADER', payload: false });
            if (res.status === 200) {
                const options = (res?.data?.data ?? [])
                    .filter((data: any) => data.isActive)
                    .sort((a: any, b: any) => (a.sortOrder > b.sortOrder ? 1 : -1))
                    .map((d: any)=>{
                        return {
                            value: d.id,
                            text: rtl ? d.reason : cancellationReasons[d.id]?.engTxt ?? d.reason
                        }
                    })
                setReasonList(options)
            } else {
                window.location.href = win['base_portal_url'] + win['errorPageURL'];
            }
        } catch (err) {
            window.location.href = win['base_portal_url'] + win['errorPageURL'];
        }
    }
    const handleSubmit = async (values: any) => {
        try {
            dispatch({ type: 'SET_LOADER', payload: true });
            const cemPublicKey = win['PK'];
            const jsencrypt = new JSEncrypt();
            jsencrypt.setPublicKey(cemPublicKey);
            const mobileNumber = jsencrypt.encrypt(msisdn);

            const response = await getODBCancelOTP(mobileNumber, lang)
            dispatch({ type: 'SET_LOADER', payload: false });
            if (response.status === 200 && response.data?.status?.sourceCode === "MAPI-000") {
                dispatch({ type: "SET_MSISDN", payload: { msisdn: msisdn, refId: response.data.data.refId, smsSentTo: response.data.data.smsSentTo, nationalId } });
                dispatch({ type: 'UPDATE_PAGE', payload: 'CANCELLATION_OTP' });
                dispatch({ type: 'UPDATE_CANCELLATION_FORM_DATA', payload: values });
            } else {
                window.location.href = win['base_portal_url'] + win['errorPageURL'];
            }
        } catch (err) {
            window.location.href = win['base_portal_url'] + win['errorPageURL'];
        }
    }

    const handleCancel = () => {
        dispatch({ type: 'UPDATE_POPUP', payload: '' })
    }

    return (
        <Modal id={'cancel-reason-modal'} rtl={rtl} close={false} contentClassName='col-10 m-auto' className='CancelReason__Modal'>
             {loading && (
                <Loading loading={loading} />
            )}
            <div className='d-flex flex-column gap-12'>
                <Typography rtl={rtl} className='CancelReason__title'>{t(`Do_you_want_to_cancel_this_FTTH_Coverage_request`)}</Typography>
                <Typography rtl={rtl} className='CancelReason__subtitle'>{t(`Please_choose_reason_of_cancelation`)}</Typography>
            </div>
            <ConfigProvider direction={direction}>
                <Form form={form} name="cancellation-form" onFinish={handleSubmit} initialValues={initialValues} onValuesChange={onValuesChange}>
                    <Form.Item
                        hasFeedback={false}
                        name='reason'
                        className={'form__fieldItem'}
                        rules={[
                            { required: true, message: `${t('Please_choose_reason_of_cancelation')}` }
                        ]}
                    >
                        <SelectComponent
                            id={`selectCancelReason`}
                            rtl={rtl}
                            headingLeft={t('')}
                            placeholder={t("select")}
                            options={reasonList}
                            showSearch={true}
                        />
                    </Form.Item>
                    <Form.Item shouldUpdate>
                        {({ getFieldValue }) => {
                        const reason = getFieldValue('reason');
                        return reason === 4 ? (
                            <Form.Item
                                hasFeedback={false}
                                name='reasonText'
                                className={'form__fieldItem'}
                                rules={[
                                    { required: true, message: `${t('Please_state_your_reason')}` },
                                    {
                                        message: t(''),
                                        pattern: /^(?! )[\sA-Za-z\u0600-\u06FF]{2,255}(?<=\S)$/
                                    }
                                ]}
                            >
                                <Input
                                    rtl={rtl}
                                    headingleft={t('Please_state_your_reason')}
                                />
                            </Form.Item>
                        ) : null
                        }}
                    </Form.Item>
                    <Button htmlType={'submit'} rtl={rtl} className='CancelReason__Btn1' variant={isFormValid ? 'default' : 'disabled'}>{t(`Cancel_Request`)}</Button>
                    <Button rtl={rtl} className='CancelReason__Btn2' onClick={handleCancel}>{t(`Go_Back`)}</Button>
                </Form>
                </ConfigProvider>
        </Modal>
    )
}

export default CancelReasonModal